import { KeyboardEventCheck } from '@Tools/KeyboardEventCheck';
import cn from 'classnames';
import React, { useEffect, useReducer, useRef } from 'react';
import type { IButtonProps } from './Button.types';

// REDUX
import { getGlobalStyles, getUIState } from '@Managers/Redux/AppState/AppState';
import { useAppSelector } from '@Managers/Redux/Hooks';
import styles from '@UILayer/UILayer.scss';

const Button: React.FC<IButtonProps> = ({
    id,
    dataElement,
    className,
    children,
    onChange,
    description,
    focus = false,
    dataDismiss,
    uiFreezeCheck = true,
    style = {}
}) => {
    const [state, setState] = useReducer((state: { disabled: boolean }, newState: any) => ({ ...state, ...newState }), {
        disabled: false
    });
    const onClick = (e?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        if (!state.disabled) onChange();
    };

    const textInput = useRef<HTMLButtonElement>(null!);
    const globalStyles = useAppSelector(getGlobalStyles);
    const uiState = useAppSelector(getUIState);
    const classes = cn(className, globalStyles.wcaMode, globalStyles.orientation, state.disabled ? styles.disabled : {});

    useEffect(() => {
        let disabled = false;
        if (uiState.uiFreeze && uiFreezeCheck) disabled = true;

        setState({ disabled: disabled });
    }, [uiState.uiFreeze]);

    return (
        <button
            ref={textInput}
            id={id}
            autoFocus={focus}
            tabIndex={0}
            aria-description={description}
            className={classes}
            onKeyDown={(e) => KeyboardEventCheck(e, onChange)}
            onPointerDown={(e) => onClick(e)}
            data-element={dataElement}
            data-dismiss={dataDismiss}
            style={style}
        >
            {children}
        </button>
    );
};

export default Button;
